// Carte bancaire par internet
export const TYPE_PRINCIPAL = 'Régisseur';
// Prélèvement par internet
export const TYPE_SUPPLEANT = 'Régisseur suppléant';
// Règlement interne
export const TYPE_AGENT = 'Agent de guichet';

export const TYPES = [TYPE_PRINCIPAL, TYPE_SUPPLEANT, TYPE_AGENT];
